import Grid from '@mui/material/Grid';
import { Box, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CardMarkerSmall from '../../../components/CockpitCards/CardMarkerSmall';
import PwChangeForm from './PwChangeForm';
import { useTranslation } from '../../../language';


export default function PasswordCard() {

  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const glassCardSx = {
    bgcolor: isDark ? alpha('#fff', 0.04) : alpha('#fff', 0.5),
    backdropFilter: 'blur(28px) saturate(180%)',
    WebkitBackdropFilter: 'blur(28px) saturate(180%)',
    border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.65)'}`,
    boxShadow: isDark
      ? 'inset 0 1px 0 rgba(255,255,255,0.06), 0 8px 32px rgba(0,0,0,0.55)'
      : 'inset 0 1px 0 rgba(255,255,255,0.7), 0 4px 24px rgba(0,0,0,0.06)',
  };

  return (
    <Grid size={{ xs: 12 }} sx={{ maxWidth: 800, width: '100%', px: { xs: 2, sm: 0 }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      <Box sx={{ width: '100%', mb: 4 }}>
        <CardMarkerSmall
          headline={t('ua_pw_dash_header')}
          subtext={
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>{t('ua_pw_dash_subline')}</Typography>
              <Typography variant="subtitle2" sx={{ fontWeight: 400, mt: 2 }}>{t('ua_pw_dash_subline_gen')}</Typography>
              <Typography variant="subtitle2" sx={{ fontWeight: 400, mt: 2 }}>{t('ua_pw_dash_subline_sec')}</Typography>
            </Box>
          }
          cardlines={<PwChangeForm />}
          sx={glassCardSx}
        />
      </Box>

    </Grid>
  );
}
